import Vue from 'vue'

export default {
  // Extracts strings of the default and selected language to display in the UI
  getTranslationsForLanguage (
    config, // The configuration object containing translations
    defaultLanguage = 'en',
    selectedLanguage,
    shouldExtractFieldType = false // Must be set 'true' for Landing Page
  ) {
    const translationsStrings = {} // Stores key-value pairs for the default language
    const translatedStrings = {} // Stores key-value pairs for the selected language

    // Recursively extracts translation strings from the config object
    const extractTranslationsFromConfig = function (
      configElement, // Current element in the config tree
      accumulatedKey = '', // Key path built from parent keys
      lastFoundFieldType = '' // Most recent field type encountered
    ) {
      if (Array.isArray(configElement)) {
        configElement.forEach(function (item, index) {
          if (typeof item === 'object' && item !== null) {
            const updatedKey = accumulatedKey ? `${accumulatedKey}:${index}` : `${index}`
            const updatedFieldType = shouldExtractFieldType && item.type ? item.type : lastFoundFieldType

            extractTranslationsFromConfig(item, updatedKey, updatedFieldType)
          }
        })
      } else if (typeof configElement === 'object' && configElement !== null) {
        Object.entries(configElement).forEach(function ([key, value]) {
          if (Array.isArray(value)) {
            const updatedKey = accumulatedKey ? `${accumulatedKey}:${key}` : key
            extractTranslationsFromConfig(value, updatedKey, lastFoundFieldType)
          } else if (typeof value === 'object' && value !== null) {
            const updatedFieldType = shouldExtractFieldType && value.type ? value.type : lastFoundFieldType

            if ((value[defaultLanguage] && typeof value[defaultLanguage] === 'string') || (value[selectedLanguage] && typeof value[selectedLanguage] === 'string')) {
              const baseKey = accumulatedKey ? `${accumulatedKey}:${key}` : key
              // Tag the fields that carry no type in the config so that they still get the image/URL handling
              const impliedFieldTypes = { 'footer:background': 'image', 'footer:privacy': 'url', 'cookie:link': 'url' }
              const fieldType = impliedFieldTypes[baseKey] || updatedFieldType
              const finalKey = fieldType ? `${baseKey}:${fieldType}` : baseKey

              translationsStrings[finalKey] = value[defaultLanguage] || ''
              if (selectedLanguage) {
                translatedStrings[finalKey] = value[selectedLanguage] || ''
              }
            } else {
              const updatedKey = accumulatedKey ? `${accumulatedKey}:${key}` : key
              extractTranslationsFromConfig(value, updatedKey, updatedFieldType)
            }
          }
        })
      }
    }

    extractTranslationsFromConfig(config)
    return { translationsStrings, translatedStrings }
  },

  // Updates the selected language's strings in the config JSON when they are changed in the UI
  // hasUsedMachineTranslate must be set to true during machine translation
  updateConfigStringsLogic (config, languages, strings, defaultLanguage, hasUsedMachineTranslate = false) {
    const getConfigVariable = (key, configElement) => {
      if (key.includes(':')) {
        const subKey = key.split(':')[0]
        const endKey = key.slice(key.indexOf(':') + 1)
        if (configElement[subKey] && typeof configElement[subKey] === 'object' && !Array.isArray(configElement[subKey]) && configElement[subKey][defaultLanguage]) {
          return configElement[subKey]
        } else if (!Array.isArray(configElement[subKey])) {
          return getConfigVariable(endKey, configElement[subKey])
        } else {
          const index = parseInt(key.split(':')[1])
          const remainingKey = key.split(`${subKey}:${index}:`)[1]
          return getConfigVariable(remainingKey, configElement[subKey][index])
        }
      } else {
        return configElement[key]
      }
    }

    for (const [key, value] of Object.entries(strings)) {
      const configStringObj = getConfigVariable(key, config)
      if (!configStringObj || typeof configStringObj !== 'object') continue
      if (languages.length === 1) {
        Vue.set(configStringObj, languages[0], value)
      } else {
        languages.forEach((lang) => {
          // Prevent links from being overwritten by the default language's unless empty, in which case copies over the default language's link
          if (hasUsedMachineTranslate) {
            const splitKeys = key.split(':')
            const fieldElement = splitKeys[splitKeys.length - 2]
            const fieldType = splitKeys[splitKeys.length - 1]
            if (fieldElement === 'url' || fieldType === 'url' || fieldType === 'image' || fieldType === 'video' || fieldType === 'iframe') {
              if (configStringObj[lang.key]) return
              Vue.set(configStringObj, lang.key, value[languages[0].key])
              return
            }
          }
          Vue.set(configStringObj, lang.key, value[lang.key])
        })
      }
    }

    return config
  }
}
